import { CreateUpdateMooringComponent, MooringComponent } from './MooringComponent';

class BaseMooringBridle {
  MoorlogNo!: string;
  AnalysisNo!: string;
  DimForce?: number;
  IsAccident!: boolean;

  BuoyId!: number;
  BuoyNo?: string;

  CageId!: number;
  CageNo?: string;

  MblRopes?: number;
  MblSinkRopes?: number;
  MblStraps?: number;
  MblChainShackleConnectionPlates?: number;
  MblUsedChainRopeWithKnot?: number;
  CalculatedLength!: number;
}

export class UpdateMooringBridleDto extends BaseMooringBridle {
  Id!: number;
  Components!: CreateUpdateMooringComponent[];
}

export class AddMooringBridleDto {
  MoorlogNo!: string;
  AnalysisNo!: string;
  BuoyId!: number;
  CageId!: number;
}

export class MooringBridle extends BaseMooringBridle {
  Id!: number;
  Components!: MooringComponent[];
  HasUnresolvedComments!: boolean;
  HasUnresolvedComponentComments!: boolean;
  HasComments!: boolean;
}

export class MooringProductionBridleDto {
  CageId!: number;
  MooringId!: number;
  MoorlogNo!: string;
  AnalysisNo!: string;
  RingType!: string;
  MblRopes!: number | null;
  MblStraps!: number | null;
  MblChainShackleConnectionPlates!: number | null;
  Strap!: string;
  StrapUtilizationFactor!: number | null;
  StrapLength!: string;
  NoBridles!: number;
  RopeDimension!: string;
  RopeType!: string;
  RopeMbl!: number | null;
  RopeUtilizationFactor!: number | null;
  LengthCenterBridle!: number | null;
  LengthOuterBridle!: number | null;
  RopeSlot!: MooringProductionBridleSlotDto | null;
  StrapSlot!: MooringProductionBridleSlotDto | null;
}

export class MooringProductionBridleSlotDto {
  BridleId?: number;
  ComponentId?: number;
  ArticleProductId?: number;
  ProductName?: string;
}

export class MooringProductionBridleEditDto {
  CageId!: number;
  RopeSlot?: MooringProductionBridleSlotDto;
  StrapSlot?: MooringProductionBridleSlotDto;
}
